import React from "react";
import mindset from "../../images/articles/2025Bang/blogsMindset.png";
import skillSet from "../../images/articles/2025Bang/blogsSkillset.png";
import toolSet from "../../images/articles/2025Bang/blogToolSet.png";
import "../../styles/blogs.css";

const start2025WithABang = () => {
  return (
    <>
      <section className="blog">
        <div className="blogIntro">
          <h1>Start 2025 With A Bang</h1>
          <h2>Equip yourself with the right mindset, skillset and toolset.</h2>
          <p>
            As we enter the New Year, thoughts will turn to having a ‘fresh
            start’ and setting out new goals and ambitions for the year ahead.
            Whether this is professionally or personally, ensuring you have the
            right mindset is key, but to make these goals a reality, equipping
            yourself with the right skillset and toolset is vital. There are
            many things that are proven to unlock this success, but most
            importantly it’s about harnessing the right mindset, skillset and
            toolset…
          </p>
        </div>
        <div className="blogPara">
          <h3>Mindset</h3>
          <p>
            It’s no surprise that having the right mindset is the crucial first
            step in ensuring success. Here are some key areas within your
            mindset to consider:
          </p>
          <img src={mindset} alt="Mindset" />
          <p>
            <span className="strong">Growth</span>: we may not always get it
            right, but we can certainly always learn. Put simply, it’s the
            concept that over time, your skills and abilities can be improved.
            In contrast, you have someone with a ‘fixed mindset’, who believes
            this cannot be changed. So, how can you ensure you have a growth
            mindset?
          </p>
          <ul className="blogList">
            <li>
              Flip your thinking. Don’t let your negative thoughts prevent you
              from growing. Instead, allow yourself to be challenged and push
              your thinking from being fixed on ‘I can’t do this’ to ‘in time,
              and with practice, I can do it’.
            </li>
            <li>
              Learn from mistakes. If something didn’t work, find out why? Don’t
              fear failing, see it as the opportunity to learn and grow.
            </li>
          </ul>
          <p>
            <span className="strong">Positive attitude</span>: positivity isn’t
            just about smiling and looking happy, when it comes to a positive
            attitude this is more focussed on a person's perspective on life and
            looking at the good over the negative. There are many
            characteristics of a ‘positive’ mindset, which include:
          </p>
          <ul className="blogList">
            <li>
              Optimism - being willing to make that effort and not just think
              something won’t work and therefore not try.
            </li>
            <li>
              Acceptance - things won’t always work out as you planned, but it’s
              how you react to that and accepting it and learning from mistakes
              is key.
            </li>
            <li>Gratitude - appreciating all the good things in your life.</li>
            <li>
              Resilience - the ability to bounce back from disappointment or
              failure instead of just giving up.
            </li>
            <li>
              Mindfulness & consciousness - this is about dedicating your mind
              to conscious awareness and enhancing its ability to focus.
            </li>
            <li>
              Integrity - being honorable, clear and straightforward rather than
              being deceitful.
            </li>
          </ul>
          <p>
            Having the right mindset is complemented by setting out goals for
            success that are stretching, but most importantly, achievable. It’s
            then about the small steps in between that, and being equipped with
            a growth and positive mindset, which help you reach it.
          </p>
        </div>
        <div className="blogPara">
          <h3>Skill Set</h3>
          <p>
            In this section we’ll take a look at the skills needed to reach your
            goals. When it comes to learning, it’s continuous, it isn’t a one
            stop shop.
          </p>
          <img src={skillSet} alt="Skillset" />
          <p>
            Your skill set is a collection of abilities, knowledge and
            competencies. These can be attained through learning such as
            education and training, as well as life experiences and practice.
            Your skillset is important for so many reasons. It’s crucial for
            success, whether that is personal or professional development. How
            does this benefit you?
          </p>
          <ul>
            <li>
              Increased employability - give yourself that advantage in the job
              market and be at the top of your game in your industry.
            </li>
            <li>
              Improved productivity - with better productivity means you’ll
              perform tasks far more effectively and efficiently, and in turn,
              better results.
            </li>
            <li>
              Confidence boost - if your skill set is strong this gives you a
              huge confidence boost, making you feel much more secure and able
              to take on new challenges.
            </li>
            <li>
              Personal growth - when you develop your skill set, you’re also
              developing yourself as a person.
            </li>
          </ul>
          <p>
            How you set to improve or attain this skill set can vary as
            mentioned from training and education, to life experiences. There
            are many common skill sets which help in the workplace, including;
            adaptability, communication, conflict resolution, critical thinking,
            creativity, management and problem solving. Effective training can
            help you develop these skills.
          </p>
        </div>
        <div className="blogPara">
          <h3>Tool Set</h3>
          <p>
            The final area to mention is looking at your toolset and what you
            might call on to help you achieve your goals. This could be tools,
            technology, methodology and resources (such as people) needed to
            help.
          </p>
          <img src={toolSet} alt="Toolset" />
          <p>
            In short, having the correct tools and resources at your disposal
            makes tasks easier and you more efficient.
          </p>
          <p>
            By integrating all three of these, you’re in a much better position
            to be set up for success. If you’re someone who looks to improve
            their mindset, skill set and toolset, you’ll naturally start
            improving as well as continually learning. We saw a brilliant
            analogy of this where you can think of it as the three legs of a
            stool. Without the three legs, the stool wouldn’t stand tall.
            Similarly, in order to grow and reach your goals you need to invest
            in these three areas. This shift will ensure that you master success
            and start 2024 with a bang!
          </p>
        </div>
      </section>
    </>
  );
};

export default start2025WithABang;
